import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import Home from "@/pages/home/page";
import Episodes from "@/pages/episodes/page";
import EpisodeDetail from "@/pages/episode-detail/page";
import Actors from "@/pages/actors/page";
import ActorDetail from "@/pages/actor-detail/page";
import News from "@/pages/news/page";
import NewsDetail from "@/pages/news-detail/page";
import About from "@/pages/about/page";
import NotFound from "@/pages/NotFound";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "episodes", element: <Episodes /> },
      { path: "episode/:id", element: <EpisodeDetail /> },
      { path: "actors", element: <Actors /> },
      { path: "actor/:id", element: <ActorDetail /> },
      { path: "news", element: <News /> },
      { path: "news/:id", element: <NewsDetail /> },
      { path: "about", element: <About /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;